export default "__VITE_ASSET__0c6dd1fb__"